import { Ref, SelectOption, Select, Text } from "@tblabs/truffle";
import { Product } from "../../../Models/Product/Product";
import { Box } from "./Box";


export class OptionSelectionBox extends Box
{
    constructor(product: Product, productOption: Ref<string>)
    {
        const options = product.Options.List.Items.map(x => new SelectOption(x.Label.value + " " + product.Options.FactorAsLabel(x.Url.value), x.Url.value));

        const optionDescription = new Ref<string>("");

        productOption.OnChange(v => optionDescription.value = product.Options.GetById(v).Description.value, true);

        super("product-option-selector", [
            new Select(productOption, options).WidthPercent(100),
            new Text(optionDescription).Class("product-option-selector-description")
                .VisibleWhen(optionDescription, v => v.length > 0),
        ]);

        this.DisplayBlock().FullWidth().Background("#1e293b").Padding(12).BorderRadius(8).Margin(0)

        this.Visible(options.length > 0);
    }
}
